<div class="flex f-fd--column f-gap--25px f-jc--center f-ai--center margin-20">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <span>{{msg}}</span>
</div>
